import SubscriptionPlan from "types/enums/SubscriptionPlan"

const subscriptionPlanFeatures: {
  name: string
  [SubscriptionPlan.E_PLUS]: string
  [SubscriptionPlan.NETWORK]: string
  [SubscriptionPlan.PLUS]: string
  [SubscriptionPlan.BASIC]: string
  [SubscriptionPlan.BASIC_MAY_2025]: string
  [SubscriptionPlan.SUPREME]: string
  [SubscriptionPlan.BASIC_OCT_2025]: string
  [SubscriptionPlan.BASIC_DEC_2025]: string
  [SubscriptionPlan.GROWTH]: string
  [SubscriptionPlan.GROW_MARCH_2026]: string
  [SubscriptionPlan.START]: string
  [SubscriptionPlan.BASIC_MAY_2026]: string
  [SubscriptionPlan.NETWORK_JULY_2026]: string
  [SubscriptionPlan.BASIC_JULY_2026]: string
}[] = [
  {
    name: "Install Quantity",
    [SubscriptionPlan.E_PLUS]: "Unlimited",
    [SubscriptionPlan.NETWORK]: "Unlimited",
    [SubscriptionPlan.PLUS]: "-",
    [SubscriptionPlan.BASIC]: "-",
    [SubscriptionPlan.BASIC_MAY_2025]: "-",
    [SubscriptionPlan.SUPREME]: "-",
    [SubscriptionPlan.BASIC_OCT_2025]: "-",
    [SubscriptionPlan.BASIC_DEC_2025]: "-",
    [SubscriptionPlan.GROWTH]: "-",
    [SubscriptionPlan.GROW_MARCH_2026]: "-",
    [SubscriptionPlan.START]: "Up to 250",
    [SubscriptionPlan.BASIC_MAY_2026]: "Up to 500",
    [SubscriptionPlan.NETWORK_JULY_2026]: "Unlimited",
    [SubscriptionPlan.BASIC_JULY_2026]: "Up to 500",
  },
  {
    name: "24/7 Tstat Logo Display",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "check",
    [SubscriptionPlan.BASIC_DEC_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
    [SubscriptionPlan.GROW_MARCH_2026]: "check",
    [SubscriptionPlan.START]: "check",
    [SubscriptionPlan.BASIC_MAY_2026]: "check",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "check",
  },
  {
    name: "Nuve Home App",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "check",
    [SubscriptionPlan.BASIC_DEC_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
    [SubscriptionPlan.GROW_MARCH_2026]: "check",
    [SubscriptionPlan.START]: "check",
    [SubscriptionPlan.BASIC_MAY_2026]: "check",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "check",
  },
  {
    name: "Contractors University",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
    [SubscriptionPlan.GROW_MARCH_2026]: "check",
    [SubscriptionPlan.START]: "check",
    [SubscriptionPlan.BASIC_MAY_2026]: "check",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "check",
  },
  {
    name: "Email - Thermostat Alerts",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "check",
    [SubscriptionPlan.BASIC_DEC_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
    [SubscriptionPlan.GROW_MARCH_2026]: "check",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "check",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "check",
  },
  {
    name: "Nuve Dashboard Center",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "check",
  },
  {
    name: "24/7 Monitoring",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Remote Performance Test",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "check",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "check",
    [SubscriptionPlan.GROWTH]: "check",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Messaging Center",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "check",
    [SubscriptionPlan.BASIC]: "check",
    [SubscriptionPlan.BASIC_MAY_2025]: "check",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "check",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "check",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Custom App Icon",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Custom Boxes",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Intelligence Reporting",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Custom Dashboard",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Nuve Pro Assist",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "check",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
  {
    name: "Warranty Benefit",
    [SubscriptionPlan.E_PLUS]: "check",
    [SubscriptionPlan.NETWORK]: "",
    [SubscriptionPlan.PLUS]: "",
    [SubscriptionPlan.BASIC]: "",
    [SubscriptionPlan.BASIC_MAY_2025]: "",
    [SubscriptionPlan.SUPREME]: "",
    [SubscriptionPlan.BASIC_OCT_2025]: "",
    [SubscriptionPlan.BASIC_DEC_2025]: "",
    [SubscriptionPlan.GROWTH]: "",
    [SubscriptionPlan.GROW_MARCH_2026]: "",
    [SubscriptionPlan.START]: "",
    [SubscriptionPlan.BASIC_MAY_2026]: "",
    [SubscriptionPlan.NETWORK_JULY_2026]: "",
    [SubscriptionPlan.BASIC_JULY_2026]: "",
  },
]

export default subscriptionPlanFeatures
